import type { VehicleProfileFilters } from '@models/vehicleProfile'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const vehicleProfilesKeys = {
  root: (companyId: number) =>
    ['companies', companyId, 'vehicleProfiles'] as const,
  vehicleProfile: (companyId: number, id: number) =>
    [...vehicleProfilesKeys.root(companyId), id] as const,
  list: (filters: VehicleProfileFilters) =>
    [
      ...vehicleProfilesKeys.root(filters.companyId),
      omit(filters, ['companyId', 'page', 'limit']),
      { page: filters.page, limit: filters.limit },
    ] as const,
}

export const vehicleProfilesUrls = {
  root: (companyId: number) => keyToUrl(vehicleProfilesKeys.root(companyId)),
  vehicleProfile: (companyId: number, id: number) =>
    keyToUrl(vehicleProfilesKeys.vehicleProfile(companyId, id)),
}
